import React from 'react';
import { useSelector } from 'react-redux';
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { FormGroup } from 'arag-ui-lib';
import QuestionEditActions from "../QuestionEditActions";
import {
    CURRENCY,
    CURRENCY_CODE,
    CURRENCY_MENU_OPTIONS
} from '../../../helpers/variables';
import { amountOnChange } from '../../../helpers/functions';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { isPigLockedQuestion } from '../../../helpers/pigLock';
import useAmountField from '../../../hooks/useAmountField';

const AmountInputType = (props) => {
    const {
        question,
        value,
        formData,
        isPlain,
        application,
        hasInlineElements,
        textHandler,
        handleBlur,
        validateAmountTypeQuestion,
        questionValidation,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        openEditQuestionAnswerModal,
        checkIfPlainEditable,
        checkIfQuestionHasPendingChanges,
        openHistoryModal,
        isLabelClickable,
    } = props;
    const { decimalError, checkDecimal } = useAmountField({
        name: question.machineName,
        value,
        onChange: (_, val) => textHandler(question.id, val),
        enabled: false,
    });
    const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.CURRENCY;

    // WI 95280: same reasoning as dropdownInputType - a locked amount question (the estimated L&C spend)
    // can be rendered inside another question's answer-edit modal, so lock it there too. Non-plain only,
    // to avoid a second tooltip on the plain Application-tab row.
    const selectedApplication = useSelector(state => state.newApplication.selectedApplication);
    const isPigLocked = !isPlain && isPigLockedQuestion(question.machineName, selectedApplication);

    return (
        <FormGroup
            variant={variant}
            labelSize={"col-sm-3"}
            inputSize={"col-sm-6 amount-input-wrapper"}
            label={question.name}
            inputProps={{
                id: `question-id-${question.id}`,
                name: question.machineName,
                label: isPlain ? value : '',
                value: isPlain ? '' : value,
                onBlur: () => handleBlur(question.id, value, null),
                onChange: (e) => { if (!checkDecimal(e.target.value)) amountOnChange((_, val) => textHandler(question.id, val), (val) => validateAmountTypeQuestion(question.id, val, null))(e); },
                disabledDropdown: true,
                handleOptionSelect: () => {},
                menuOptions: CURRENCY_MENU_OPTIONS,
                selectedCurrency: { sign: `${CURRENCY}`, code: `${CURRENCY_CODE}` },
                required: question.isRequired,
                autoComplete: 'off',
                disabled: isPigLocked,
            }}
            infoText={isPigLocked ? CONTENT_STRINGS.PIG_APPLIED_EDIT_LOCKED_TOOLTIP : undefined}
            tooltipTestId={`policy-application-${question.machineName}-info`}
            hasInlineElements={hasInlineElements}
            inlineGroupElements={
                hasInlineElements
                ?
                    <div className={"col-sm-3"}>
                        <QuestionEditActions
                            checkIfPlainEditable={checkIfPlainEditable(question, question.machineName)}
                            question={question}
                            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                            approvalOptions={approvalOptions}
                            onClick={() => openEditQuestionAnswerModal({ questionAnswerForEdit: question, questionAnswer: formData[question.id] })}
                            hasPendingChanges={checkIfQuestionHasPendingChanges( question.id, application )}
                        />
                    </div>
                :
                    null
            }
            errorMessage={decimalError || questionValidation[question.id]}
            onLabelClick={ isLabelClickable ? () => openHistoryModal(question) : undefined }
            formGroupTestId={`policy-application-${question.machineName}`}
        />
    );
};

export default AmountInputType;
